import { render, staticRenderFns } from "./UpdateTeamGramChannel.vue?vue&type=template&id=fd9e5d20&scoped=true"
import script from "./UpdateTeamGramChannel.vue?vue&type=script&lang=js"
export * from "./UpdateTeamGramChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateTeamGramChannel.vue?vue&type=style&index=0&id=fd9e5d20&prod&lang=scss&scoped=true"
import style1 from "./UpdateTeamGramChannel.vue?vue&type=style&index=1&id=fd9e5d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9e5d20",
  null
  
)

export default component.exports